import React from 'react';
import { connect } from 'react-redux';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import WidgetPreviews from 'components/WidgetPreviews';
import { widgetTypes } from '../Widgets';
import './WidgetButtons.scss';

const WidgetButtons = () => {
	return (
		<div className="WidgetButtons">
			<Droppable droppableId="buttons" isDropDisabled={true}>
				{(provided, snapshot) => (
					<div
						className="droppableButtons"
						ref={provided.innerRef}
						{...provided.droppableProps}
						style={{
							display: 'flex',
							flexWrap: 'wrap',
							justifyContent: 'center',
						}}
					>
						{widgetTypes.map((widget, index) => {
							return (
								<Draggable
									key={`${widget.type}-${index}`}
									draggableId={`${widget.type}-${index}`}
									index={index}
								>
									{(provided, snapshot) => (
										<div
											key={`${index}`}
											ref={provided.innerRef}
											{...provided.draggableProps}
											{...provided.dragHandleProps}
										>
											<div className="WidgetButton">
												<div className="WidgetPreview">
													<WidgetPreviews from="WidgetButton" type={widget.type} />
												</div>
												<h4 className="WidgetType">{widget.type}</h4>
												<div className="WidgetBody">
													<p className="WidgetDescription">{widget.description}</p>
												</div>
											</div>
										</div>
									)}
								</Draggable>
							);
						})}
						{provided.placeholder}
					</div>
				)}
			</Droppable>
		</div>
	);
};

const msp = ({ context, events }) => ({
	context,
	events: events.events,
});

export default connect(msp, null)(WidgetButtons);
